import { Box, TableCell, TableRow, Typography } from '@atgfr8/atg-ui-tailwind';
import { Button, Notification } from '@components';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { Accessor, Component, createMemo, Show } from 'solid-js';

import { LTLQuotingState } from '../types';

type SuggestLineItemClassProps = {
  suggestedClassSettingEnabled: () => boolean;
  data: Accessor<LTLQuotingState>;
  setFields: (field: string, value: unknown) => void;
  index: number;
};

const SuggestLineItemClass: Component<SuggestLineItemClassProps> = (props) => {
  const item = createMemo(() => props.data().loadItems[props.index]);

  const currentClass = createMemo(() =>
    item().class !== null && item().class !== undefined
      ? String(item().class).trim()
      : '',
  );

  const suggested = createMemo(() =>
    item().suggestedClass !== null && item().suggestedClass !== undefined
      ? String(item().suggestedClass).trim()
      : '',
  );

  const shouldShow = createMemo(
    () =>
      props.suggestedClassSettingEnabled() &&
      suggested() !== '' &&
      suggested() !== currentClass() &&
      !((item().quoteLoadItemBreakdown ?? []).length > 0),
  );

  return (
    <Show when={shouldShow()}>
      <TableRow>
        <TableCell colSpan={11}>
          <Notification
            text={
              <Box class="flex flex-wrap items-center gap-2">
                <Typography variant="body1" component="p">
                  Carrier ships at actual class based on NMFC Rules, which may
                  differ from the suggested class for density. Based on the
                  dimensions you've entered, the suggested class is Class{' '}
                  <strong>{suggested()}.</strong>
                </Typography>
                <Button
                  label="Use suggested class"
                  onClick={() => {
                    props.setFields(
                      `loadItems.${props.index}.class`,
                      suggested(),
                    );
                  }}
                  dataTestId={formatDataTestId('Use suggested class', 'button')}
                />
              </Box>
            }
            type="info"
          />
        </TableCell>
      </TableRow>
    </Show>
  );
};

export default SuggestLineItemClass;
